import { Footer } from '@/previewThemes/voltic/Footer';
import { Header } from '@/previewThemes/voltic/Header';
import { Product } from '@/previewThemes/voltic/Product';
import type { ThemePackage } from '@/previewThemes/types';

export const theme: ThemePackage = {
  Header,
  Footer,
  Product,
  listing: {
    // The densest grid we ship, and the reason this theme carries the widest
    // page column: four across beside the filter rail is what a marketplace
    // catalogue looks like, and the tight gutter is the point rather than an
    // oversight - a shopper comparing chargers wants more of them on screen.
    grid: 'grid-cols-2 gap-4 lg:grid-cols-3 xl:grid-cols-4',
    filters: 'sidebar',
    columns: 4,
    card: 'framed',
  },
  // Everything in this theme is a box on a hairline grid, the panels included.
  cart: { grid: 'mt-6 grid gap-6 lg:grid-cols-3', panel: 'outlined' },
  checkout: {
    grid: 'mt-6 grid items-start gap-6 lg:grid-cols-[minmax(0,1fr)_24rem]',
    panel: 'outlined',
  },
  search: {
    grid: 'mt-6 grid gap-6 lg:grid-cols-[240px_1fr]',
    results: 'grid grid-cols-2 gap-4 lg:grid-cols-3 xl:grid-cols-4',
    columns: 4,
    card: 'framed',
    panel: 'outlined',
  },
  blog: { list: 'grid gap-5 sm:grid-cols-2 lg:grid-cols-4', title: 'text-base' },
  category: { grid: 'grid gap-4 sm:grid-cols-3 lg:grid-cols-6', tile: 'card' },
  // What this theme used to write on `BuyBox` and `ProductGallery` by hand.
  // The merchant's components read it wherever they have left a setting at
  // "the theme's own", which is where every shop starts - so a shop nobody
  // has arranged renders the product page this theme has always drawn.
  parts: {
    product_details: {
      presentation: {
        classes: { product_title: 'text-3xl sm:text-4xl' },
        wideButtons: true,
        gallery: { thumbs: 'rail' },
      },
    },
  },
};
